import axios from "axios";
import { postalCodes } from "../services/thirdParty/geoNameApi";

export const getPostalCode = async (countryCode, city) => {
    // if (!city || !countryCode) {
    //     return "Please enter a city and country."
    // }
    // try {
    //     const response = await axios.get(
    //         `http://api.geonames.org/postalCodeSearchJSON?placename=${city}&country=${countryCode}&username=sura_testing`
    //     );
    //     if (response.data.postalCodes && response.data.postalCodes.length > 0) {
    //         return await extractUniquePostalCodes(response?.data?.postalCodes)
    //     } else {
    //         return []
    //     }
    // } catch (err) {
    //     throw new Error(err)
    // }
    try {
        const response = await postalCodes(countryCode, city);
        if (response.data.postalCodes && response.data.postalCodes.length > 0) {
            return await extractUniquePostalCodes(response?.data?.postalCodes)
        } else {
            return []
        }
    }
    catch (err) {
        throw new Error(err)
    }
};

const extractUniquePostalCodes = async (dataArray) => {
    const postalCodes = dataArray
        .map(item => item.postalCode)
        .filter(postalCode => postalCode !== undefined && postalCode !== null); // undefined/null हटाएँ

    return [...new Set(postalCodes)];
};